export const getReprocessamentoOs = (state) => state["reprocessamento-os"];
